.root {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  background: #fffbeb;
  border: 1px solid var(--rec-color-warning-border);
  border-radius: 10px;
}

.badge {
  flex: none;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--rec-color-warning);
  color: var(--rec-color-warning-fg);
  font-size: 9px;
  font-weight: 700;
}

.labels {
  flex: 1;
  min-width: 0;
  font-size: 10px;
  color: var(--rec-color-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-all {
  flex: none;
  background: none;
  border: none;
  padding: 0;
  color: var(--rec-color-purple-dot);
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 640px) {
  .root {
    align-items: flex-start;
  }

  .labels {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: unset;
    white-space: normal;
  }
}
